import { Link } from "react-router-dom";

import { Comment } from "../../components/comment/Comment";
import { CommentBody } from "../../components/comment/CommentBody";
import { ContactPostponedCommentDocument } from "../comment.model";
import { formatDateIncludingWeekday } from "../../date-utility";

interface ContactPostponedCommentProps {
    context: "customer" | "gardener";
    comment: ContactPostponedCommentDocument;
}

export const ContactPostponedComment = (props: ContactPostponedCommentProps) => {
    const { context, comment } = props;

    const gardener = (() => {
        switch ( context ) {
            case "customer": return <Link to={`/gardeners/context/${comment.gardenerId}`}>{comment.gardenerName}</Link>;
            case "gardener": return <>Havemanden</>;
        }
    })();

    const customer = (() => {
        switch ( context ) {
            case "customer": return <>kunden</>;
            case "gardener": return <Link to={`/customers/context/${comment.customerId}`}>{comment.customerName}</Link>;
        }
    })();

    return (
        <Comment date={comment.creationDate.toDate().toISOString()} title="Kontakt udskudt">
            <CommentBody>
                {gardener} har udskudt kontakten med {customer}.<br />
                <br />
                Hvornår genoptages kontakten?<br />
                {formatDateIncludingWeekday(comment.date)}<br />
                <br />
                Årsag:<br />
                {comment.reason}
            </CommentBody>
        </Comment>
    );
};
